import { useState } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // --- EmailJS SEND ---
    try {
      setStatus("sending");

      const response = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          service_id: "YOUR_SERVICE_ID",
          template_id: "YOUR_TEMPLATE_ID",
          user_id: "YOUR_PUBLIC_KEY",
          template_params: {
            name: form.name,
            email: form.email,
            message: form.message
          }
        })
      });

      if (response.ok) {
        setStatus("success");
        setForm({ name: "", email: "", message: "" });

        setTimeout(() => setStatus(""), 5000);
      } else {
        throw new Error("Error sending email");
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
      setTimeout(() => setStatus(""), 5000);
    }
  };

  return (
    <div className="w-full min-h-screen bg-gray-900 text-white pt-32 pb-20 px-6">

      {/* Header */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl md:text-5xl font-bold">
          Contact <span className="text-cyan-400">Us</span>
        </h1>
        <p className="text-gray-400 max-w-2xl mx-auto mt-4">
          Have questions? Want a quote?  
          We're here to help you grow with modern and efficient digital solutions.
        </p>
      </motion.div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">

        {/* FORM */}
        <motion.form
          onSubmit={handleSubmit}
          data-aos="fade-right"
          className="bg-gray-800/40 p-8 rounded-2xl shadow-xl border border-gray-700 backdrop-blur-xl"
        >
          <div className="mb-6">
            <label className="block text-gray-300 mb-2 font-medium">
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-lg bg-gray-900 border border-gray-700 text-white focus:border-cyan-400 outline-none transition"
              placeholder="John Doe"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-300 mb-2 font-medium">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-lg bg-gray-900 border border-gray-700 text-white focus:border-cyan-400 outline-none transition"
              placeholder="email@example.com"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-300 mb-2 font-medium">
              Your Message
            </label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows="5"
              className="w-full px-4 py-3 rounded-lg bg-gray-900 border border-gray-700 text-white focus:border-cyan-400 outline-none transition"
              placeholder="Tell us more about your project..."
            />
          </div>

          {/* Status Messages */}
          {status === "sending" && (
            <p className="text-yellow-400 mb-4 animate-pulse">Sending message…</p>
          )}
          {status === "success" && (
            <p className="text-green-400 mb-4">Message sent successfully ✔️</p>
          )}
          {status === "error" && (
            <p className="text-red-400 mb-4">There was an error. Please try again.</p>
          )}

          <button
            type="submit"
            className="w-full py-3 bg-cyan-500 hover:bg-cyan-400 text-gray-900 font-semibold rounded-xl shadow-lg transition"
          >
            Send Message
          </button>
        </motion.form>

        {/* CONTACT INFO */}
        <motion.div
          data-aos="fade-left"
          className="flex flex-col justify-center space-y-6"
        >
          <h3 className="text-3xl font-bold">
            The Kaizen <span className="text-cyan-400">Business Solutions</span>
          </h3>

          <p className="text-gray-400">
            We're committed to creating modern, scalable and efficient digital solutions for businesses.
          </p>

          <div className="space-y-3">
            <p><span className="text-cyan-400">📧 Email:</span> info@thekaizen.ca</p>
            <p><span className="text-cyan-400">📍 Location:</span> Fernie, British Columbia, Canada</p>
          </div>

          {/* Updated Map */}
          <iframe
            title="Map"
            className="w-full h-64 rounded-xl border border-gray-700"
            src="https://www.google.com/maps?q=Fernie,+British+Columbia,+Canada&output=embed"
          />
        </motion.div>

      </div>
    </div>
  );
}
